
export function isSpacingMeasureModifier(evt) {
  return Boolean(evt && evt.altKey);
}

export function isPhysicalAltKeyEvent(evt) {
  if (!evt) return false;
  return (
    evt.key === 'Alt' ||
    evt.code === 'AltLeft' ||
    evt.code === 'AltRight' ||
    evt.code === 'AltGraph'
  );
}

export function isAltModifierKeyUp(evt) {
  return isPhysicalAltKeyEvent(evt);
}
